/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { SlidesViewViewModel } from "../types/SlidesViewViewModel.ts";
import { slideImageViewModelSchema } from "./slideImageViewModelSchema.ts";

export const slidesViewViewModelSchema = z.object({
  classroomDisciplineId: z.optional(z.number().int()),
  attachmentId: z.number().int().nullish(),
  cultureInfo: z.string().nullish(),
  slideCount: z.optional(z.number().int()),
  slides: z.array(z.lazy(() => slideImageViewModelSchema)).nullish(),
}) as unknown as ToZod<SlidesViewViewModel>;
